import { formatDate, Location } from '@angular/common';
import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { InvoicingCutoffClassEnum } from 'src/app/enum/invoicing-cutoff-class-enum';
import { InvoicingCutoffEnums } from 'src/app/enum/invoicing-cutoff-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { PreviewOrderByEnums } from 'src/app/enum/preview-order-by-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { InvoicingCutoffModel } from 'src/app/models/invoicing/invoicing-cutoff.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { PreinvoicingPrintModel } from 'src/app/models/print/invoicing/preinvoicing-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoicingCutoffCostCenterModalModel } from 'src/app/models/tables/invoicing/invoicing-cutoff-cost-center-modal.model';
import { InvoicingCutoffInvoicingConceptModal } from 'src/app/models/tables/invoicing/invoicing-cutoff-invoicing-concept-modal.model';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { InvoicingCutoffDetailService } from 'src/app/services/invoicing/invoicing-cutoff-detail.service';
import { InvoicingCutoffService } from 'src/app/services/invoicing/invoicing-cutoff.service';
import { MovementService } from 'src/app/services/invoicing/movement.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { InvoicingCutoffDetailComponent } from '../../invoicing-cutoff-detail/invoicing-cutoff-detail/invoicing-cutoff-detail.component';
import { PreInvoicingComponent } from '../../pre-invoicing/pre-invoicing/pre-invoicing.component';
import { InvoiceInvoicingCutoffComponent } from '../invoice-invoicing-cutoff/invoice-invoicing-cutoff.component';

@Component({
  selector: 'app-register-invoicing-cutoff',
  templateUrl: './register-invoicing-cutoff.component.html',
  styleUrls: ['./register-invoicing-cutoff.component.scss'],
  standalone: false
})
export class RegisterInvoicingCutoffComponent implements OnInit, OnDestroy {

  @ViewChild('invoicingModal') invoicingModalComponent?: CustomModalComponent | null = null;
  @ViewChild('invoicingConceptModal') invoicingConceptModalComponent?: CustomModalComponent | null = null;
  @ViewChild('preInvoicingModal') preInvoicingModalComponent?: CustomModalComponent | null = null;
  @ViewChild('selectCostCenter') selectCostCenterModalComponent?: CustomModalComponent | null = null;
  @ViewChild('invoicingCutoffDetailComponent') invoicingCutoffDetailComponent?: InvoicingCutoffDetailComponent | null = null;

  @Input() invoicingCutoffContract: InvoicingCutoffModel = new InvoicingCutoffModel();
  @Input() permissionUpdatable: boolean = false;
  @Input() visibleListDetail: boolean = false;

  ascendantCostCenter: boolean = true;
  ascendantInvoicingConcept: boolean = true;
  branchId: number = 0;
  changeOrder: number = PreviewOrderByEnums.clienteCentroCostos;
  clientId: number | null = null;
  client: FormControl = new FormControl();
  costCenter: FormControl = new FormControl();
  costCenterType: FormControl = new FormControl();
  columnSortCostCenter: string | null = null;
  columnSortInvoicingConcept: string | null = null;
  companyCutsAmount: number = 0;
  companyId: number = 0;
  costCenterId: number | null = null;
  costCenterTypeId: number | null = null;
  costCenterWithAlerts: boolean = false;
  dataCostCenters: PagedResponseModel<InvoicingCutoffCostCenterModalModel> = new PagedResponseModel<InvoicingCutoffCostCenterModalModel>();
  dataInvoicingConcept: PagedResponseModel<InvoicingCutoffInvoicingConceptModal> = new PagedResponseModel<InvoicingCutoffInvoicingConceptModal>();
  detailWithoutMovement: boolean = false;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  disabledInvoice: boolean = true;
  disabledSelectCostCenter: boolean = false;
  disabledState: boolean = true;
  disabledSuspend: boolean = true;
  enterpriseId: number = 0;
  exporterDetailsPreview: boolean = false;
  filtersCostCenters: ColumnResponseModel[] = [];
  filtersInvoicingConcept: ColumnResponseModel[] = [];
  filteredCostCenters: any[] = [];
  filtersPreview: any[] = [];
  format: FormControl = new FormControl(1);
  formatType: boolean = true;
  formInvoicingCutoff: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  headerCostCenters: ColumnResponseModel[] = [];
  headerInvoicingConcept: ColumnResponseModel[] = [];
  hiddenSuspendBtn: boolean = false;
  iconPreviewInvoicingCutoff: string = "pi pi-eye";
  inputsForCostCenterModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
  });
  inputsForInvoicingConceptModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    selectAllByDefault: true,
    filters: [],
  });
  inputsForPreInvoicingModal$ = new BehaviorSubject<any>({
    enterpriseId: 0,
    invoicingCutoffId: 0,
    quantityCostCenterTypeThird: 0,
    branchName: '',
    invoicingCutoffCode: '',
    invoicingCutoffDate: '',
    invoicingDate: '',
    swElectronicInvoice: false
  });
  listInvoicingCutoffClass: any[] = [
    { label: 'Fra. Vencida', value: InvoicingCutoffClassEnum.expiredInvoice },
    { label: 'Fra. Anticipada', value: InvoicingCutoffClassEnum.advanceInvoice },
  ];
  invoicingCutoffId: number = 0;
  invoicingCutoffIdToUnlock: number = 0;
  invoicingCutoffStateString: string = '';
  preinvoicingCutoffStateString: string = '';
  isOpened: string | undefined = undefined;
  limitCostCenter: number = 10;
  limitInvoicingConcept: number = 10;
  listBranch: any[] = [];
  listEnterprise: any[] = [];
  listInvoicingCutoffType: any[] = [{ label: 'Movimiento', value: 2 }, { label: 'Servicio', value: 3 }];
  listUserAutheticated: Array<ItemFilterModel> = new Array<ItemFilterModel>();
  listClients: CustomListDropdown[] = [];
  listCostCenterTypes: any[] = [];
  listCostCenters: any[] = [];
  listFormatType: any[] = [
    { label: 'General', value: 1 },
    { label: 'M2', value: 2 },
  ];
  listOrder: any[] = [
    { label: 'Cliente - C.Costos', value: 1 },
    { label: 'C.Costos', value: 2 },
  ];
  mainBranchByUser: BranchModel = new BranchModel();
  movementToInvoice: Array<number> = new Array<number>();
  nameWindow: string = 'Captura Cortes de Facturación';
  openCutsAmount: number = 0;
  order: FormControl = new FormControl(1);
  output$ = new Subject<any>();
  outputInvoicingConcept$ = new Subject<any>();
  pageCostCenter: number = 1;
  pageInvoicingConcept: number = 1;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  preinvoicingPrintModel: PreinvoicingPrintModel[] = [];
  previewInvoicingCutoff: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  quantityCostCenterTypeThird: number = 0;
  subscription: Subscription;
  subscriptionInvoicingConcept: Subscription;
  swAdvanceInvoice: boolean = false;
  swElectronicInvoice: boolean = false;
  swPartialInvoicing: boolean = false;
  swServicesFullSeparately: boolean = false;
  swSpecialInvoicing: boolean = false;
  titlePreviewInvoicingCutoff: string = "Vista Previa";
  updateListDetail: boolean = false;
  url: string = 'invoicing-cutoff';
  userAuthenticated: UserModel = new UserModel();
  userIdBlock: number | null = null;
  userNameBlock: string = "";
  visibleBlock: boolean = false;
  visibleLoading: boolean = true;
  componentTableSelection = CustomTableSelectComponent;
  invoicingComponent = InvoiceInvoicingCutoffComponent;
  invoicingConceptSelectionComponent = CustomTableSelectComponent;
  preInvoicingComponent = PreInvoicingComponent;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private costCenterService: CostCenterService,
    private confirmDialogService: ConfirmDialogService,
    private dateConverterService: DateConverterService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private formatService: FormatService,
    private headerService: HeaderService,
    private invoiceService: InvoiceService,
    private invoicingCutoffDetailService: InvoicingCutoffDetailService,
    private invoicingCutoffService: InvoicingCutoffService,
    private generalParameterService: GeneralParameterService,
    private location: Location,
    private movementService: MovementService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(this.invoicingCutoffContract);
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.invoicingCutoffId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeCostCenter(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeCostCenter(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
    this.subscriptionInvoicingConcept = this.outputInvoicingConcept$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeConcept(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeInvoicingConcept(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
    this.headerService.setTitle(this.nameWindow);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    try {
      const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
      if (windowsOpenedJson) {
        const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
        const windowIndex = windowsOpened.findIndex(x => x === this.url);
        if (windowIndex !== -1) {
          windowsOpened.splice(windowIndex, 1);
          localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
          firstValueFrom(this.invoicingCutoffService.unlockAllInvoicingCutoff());
        }
      }
    } catch (error) {
      console.error('Problemas al ejecutar ngOnDestroy()', error);
    }
  }

  async changeBranch(branchId: number) {
    const invoicingCutoffClass = this.formInvoicingCutoff.get("invoicingCutoffClass")?.value;
    this.invoicingCutoffContract = new InvoicingCutoffModel();
    this.invoicingCutoffContract.branchId = branchId;
    this.invoicingCutoffContract.invoicingCutoffClass = invoicingCutoffClass;
    this.invoicingCutoffId = this.invoicingCutoffContract.invoicingCutoffId;
    this.invoicingCutoffIdToUnlock = 0;
    this.validateForm(this.invoicingCutoffContract);
    await this.getAllLists(true);
  }

  async changeConsecutive(consecutive: number) {
    const branchId = this.formInvoicingCutoff.get("branchId")?.value;
    const invoicingCutoffClass = this.formInvoicingCutoff.get("invoicingCutoffClass")?.value;

    if (branchId === null || branchId === 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }
    try {
      this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.getInvoicingCutoffByKeysAsync(
        this.branchId, consecutive, invoicingCutoffClass, this.invoicingCutoffIdToUnlock)
      );
      this.invoicingCutoffId = this.invoicingCutoffContract.invoicingCutoffId;
      this.invoicingCutoffIdToUnlock = 0;
      this.validateForm(this.invoicingCutoffContract);
    } catch (error) {
      this.invoicingCutoffContract = new InvoicingCutoffModel();
      this.invoicingCutoffContract.branchId = branchId;
      this.invoicingCutoffId = this.invoicingCutoffContract.invoicingCutoffId;
      this.invoicingCutoffIdToUnlock = 0;
      this.validateForm(this.invoicingCutoffContract);
      console.error('Error al obtener el corte de facturación por claves.', error);
    }

  }

  changeOrderBy(order: any) {
    this.changeOrder = order;
  }

  clearFilters() {
    this.clientId = null;
    this.costCenterId = null;
    this.costCenterTypeId = null;

    this.client.patchValue(null);
    this.costCenter.patchValue(null);
    this.costCenterType.patchValue(null);
    this.filteredCostCenters = this.listCostCenters;
    this.updateFilters();
  }


  async createDetail(costCenters: InvoicingCutoffCostCenterModalModel[]) {
    const availablePlaces = 500 - this.quantityDetails;
    if (costCenters && costCenters.length > availablePlaces) {
      this.toastHandlerService.showToast('warning', `No se pueden agregar más de ${availablePlaces} centros de costos.`);
      return;
    }
    if (costCenters.length != 0) {
      const costCentersIds = costCenters.map(d => d.costCenterId);
      try {
        await firstValueFrom(this.invoicingCutoffDetailService.createInvoicingCutoffDetail(this.invoicingCutoffId, costCentersIds));
        this.updateListDetail = !this.updateListDetail;
      } catch (error) {
        this.updateListDetail = !this.updateListDetail;
        console.error('Error al crear los detalles del corte de facturación.', error);
      }
    }
  }

  async createNewInvoicingCutoff(branchId: number, invoicingCutoffClass?: number) {
    if (this.permissionUpdatable) {
      await this.validateCountInvoicingCutoffsOpen(this.branchId);

      if (this.companyCutsAmount != 0) {
        if (this.companyCutsAmount == this.openCutsAmount) { return; }
      }

      const branchIdNew = branchId !== 0 ? branchId : this.mainBranchByUser.branchId;
      this.userIdBlock = null;
      this.invoicingCutoffId = 0;
      this.invoicingCutoffIdToUnlock = 0;
      this.invoicingCutoffContract.branchId = branchIdNew;
      this.invoicingCutoffContract.consecutive = 0;
      this.invoicingCutoffContract.userIdBlock = this.userIdBlock;
      this.invoicingCutoffContract.invoicingCutoffTypeId = this.swServicesFullSeparately ?
        InvoicingCutoffEnums.tipoMovimiento : InvoicingCutoffEnums.tipoCompleto;
      if (invoicingCutoffClass !== null && invoicingCutoffClass !== undefined) {
        this.invoicingCutoffContract.invoicingCutoffClass = invoicingCutoffClass;
      }
      this.validateForm(this.invoicingCutoffContract);
      this.getBranch(branchIdNew, true);
      if (this.permissionUpdatable) {
        this.disabledState = false;
      } else {
        this.updateFormPermision();
      }
      this.quantityDetails = 0;
      this.router.navigate(['/invoicing-cutoff/register']);
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear cortes de facturación. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async deleteCostCentersWithAlerts() {
    const accepted = await this.confirmDialogService.confirm("¿Realmente desea eliminar los centros de costos con alertas y sin movimiento del corte de facturación?");
    if (accepted) {
      try {
        await firstValueFrom(this.invoicingCutoffService.deleteCostCentersWithAlerts(this.invoicingCutoffId));
        this.costCenterWithAlerts = false;
        this.toastHandlerService.showToast('success', 'Los centros de costos con alertas fueron eliminados exitosamente.');
        this.invoicingCutoffDetailComponent?.getInvoicingCutoffDetailsForRegisterTable();
      } catch (error) {
        console.error("Error al eliminar los centros de costos con alertas del corte de facturación: ", error);
      }
    }
  }

  async deleteInvoicingCutoff() {
    if (this.invoicingCutoffContract.invoicingCutoffId != 0 && this.invoicingCutoffContract.invoicingCutoffId != null) {
      if (this.permissionUpdatable) {
        if (this.invoicingCutoffContract.userIdBlock !== 0 && this.invoicingCutoffContract.userIdBlock !== null) {
          if (this.invoicingCutoffContract.invoicingCutoffStateId === InvoicingCutoffEnums.estadoAbierto) {
            const accepted = await this.confirmDialogService.confirm("¿Realmente desea eliminar el corte de facturación actual?");
            if (accepted) {
              try {
                await firstValueFrom(this.invoicingCutoffService.deleteInvoicingCutoff(this.invoicingCutoffId));
                this.createNewInvoicingCutoff(0);
                this.toastHandlerService.showToast(
                  'success',
                  'El corte de facturación fue eliminado exitosamente.'
                );
              } catch (error) {
                console.error("Error al eliminar el corte de facturación: ", error);
              }
            }
          } else {
            this.toastHandlerService.showToast(
              'warning',
              'Para eliminar el corte de facturación debe estar en estado Abierto.'
            );
          }
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'El corte de facturación se encuentra bloqueado por un usuario.'
          );
          return;
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para eliminar cortes de facturación. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un corte de facturación.'
      );
      return;
    }

  }

  exporterDetailsPreviewPrint() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.ExportarVistaPrevia)) {
      this.exporterDetailsPreview = !this.exporterDetailsPreview;
    } else {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para exportar la Vista Previa de cortes de facturación, comuniquese con el administrador del sistema.', 'Atención');
    }
  }

  filterCostCenterByClientId(clientId: number | null) {
    const rowsFiltered = this.listCostCenters.filter(
      (cc) => cc.clientId === clientId
    );
    if (clientId != null) {
      this.filteredCostCenters = rowsFiltered;
    } else {
      this.filteredCostCenters = this.listCostCenters;
    }
  }

  async getAllLists(reload: boolean) {
    try {
      if (reload) {
        const enterprises = await firstValueFrom(this.invoicingCutoffService.getAllEnterprisesForSelectAsync(this.branchId));
        this.listEnterprise = enterprises;
      } else {
        const [branches, enterprises] = await Promise.all([
          firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
          firstValueFrom(this.invoicingCutoffService.getAllEnterprisesForSelectAsync(this.branchId))
        ]);

        this.listBranch = branches;
        this.listEnterprise = enterprises;
      }

      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getAllListFilters() {
    try {
      const [clients, costCenters, costCenterTypes] = await Promise.all([
        firstValueFrom(this.invoiceService.getAllClientsForSelectAsync()),
        firstValueFrom(
          this.invoiceService.getAllCostCenterForPreinvoiceSelectAsync()
        ),
        firstValueFrom(this.costCenterService.getCostCenterTypesForSelect()),
      ]);
      this.listClients = clients;
      this.listCostCenters = costCenters;
      this.filteredCostCenters = this.listCostCenters;
      this.listCostCenterTypes = costCenterTypes;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    if (branchId != null) {
      const branch = this.listBranch.find(x => x.value == branchId);
      if (branch) {
        this.branchId = branchId;
      } else {
        this.formInvoicingCutoff.controls["branchId"].setValue(0);
        return;
      }
    } else {
      this.formInvoicingCutoff.controls["branchId"].setValue(0);
    }
    if (branchId && reload) {
      await this.changeBranch(branchId);
      this.getFirstEnterpriseByBranch(branchId);
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formInvoicingCutoff.get("branchId")?.value;
    const invoicingCutoffClass = this.formInvoicingCutoff.get("invoicingCutoffClass")?.value;
    const consecutive = this.formInvoicingCutoff.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.getFirstInvoicingCutoffByKeysAsync(
            branchId, invoicingCutoffClass, this.invoicingCutoffIdToUnlock)
          );
          this.invoicingCutoffId = this.invoicingCutoffContract.invoicingCutoffId;
          this.invoicingCutoffIdToUnlock = this.invoicingCutoffId;
          this.validateForm(this.invoicingCutoffContract);
          this.location.replaceState(`/invoicing-cutoff/register/${this.invoicingCutoffId}`);
        } catch (error) {
          this.createNewInvoicingCutoff(branchId);
          console.error('Error al obtener el primer corte de facturación por claves.', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.getPreviusInvoicingCutoffByKeysAsync(
            branchId, consecutive, invoicingCutoffClass, this.invoicingCutoffIdToUnlock)
          );
          this.invoicingCutoffId = this.invoicingCutoffContract.invoicingCutoffId;
          this.invoicingCutoffIdToUnlock = this.invoicingCutoffId;
          this.validateForm(this.invoicingCutoffContract);
          this.location.replaceState(`/invoicing-cutoff/register/${this.invoicingCutoffId}`);
        } catch (error) {
          this.createNewInvoicingCutoff(branchId);
          console.error('Error al obtener el anterior corte de facturación por claves.', error);
        }
        break;
      }
      case 'next': {
        try {
          this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.getNextInvoicingCutoffByKeysAsync(
            branchId, consecutive, invoicingCutoffClass, this.invoicingCutoffIdToUnlock)
          );
          this.invoicingCutoffId = this.invoicingCutoffContract.invoicingCutoffId;
          this.invoicingCutoffIdToUnlock = this.invoicingCutoffId;
          this.validateForm(this.invoicingCutoffContract);
          this.location.replaceState(`/invoicing-cutoff/register/${this.invoicingCutoffId}`);
        } catch (error) {
          this.createNewInvoicingCutoff(branchId);
          console.error('Error al obtener el siguiente corte de facturación por claves.', error);
        }
        break;
      }
      case 'last': {
        try {
          this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.getLastInvoicingCutoffByKeysAsync(
            branchId, invoicingCutoffClass, this.invoicingCutoffIdToUnlock)
          );
          this.invoicingCutoffId = this.invoicingCutoffContract.invoicingCutoffId;
          this.invoicingCutoffIdToUnlock = this.invoicingCutoffId;
          this.validateForm(this.invoicingCutoffContract);
          this.location.replaceState(`/invoicing-cutoff/register/${this.invoicingCutoffId}`);
        } catch (error) {
          this.createNewInvoicingCutoff(branchId);
          console.error('Error al obtener el último corte de facturación por claves.', error);
        }
        break;
      }
    }
    if (this.previewInvoicingCutoff) {
      this.getPrintPreinvoincing();
    }
  }

  async getClient(clientId: number) {
    this.filterCostCenterByClientId(clientId);
    this.clientId = clientId;
    this.updateFilters();
  }

  async getCostCenter(costCenterId: number | null) {
    this.costCenterId = costCenterId;
    this.updateFilters();
  }

  async getCostCenterTypes(costCenterTypeId: number | null) {
    this.costCenterTypeId = costCenterTypeId;
    this.updateFilters();
  }

  async getColumnsCostCenters() {
    try {
      if (this.headerCostCenters.length === 0) {
        this.headerCostCenters = await firstValueFrom(
          this.invoicingCutoffDetailService.getColumnsForCostCenters()
        );
      }
    } catch (error) {
      console.error('Error al obtener las columnas de los centros de costos.', error);
    }
  }

  async getColumnsInvoicingConcepts() {
    try {
      if (this.headerInvoicingConcept.length === 0) {
        this.headerInvoicingConcept = await firstValueFrom(
          this.invoicingCutoffDetailService.getColumnsForInvoicingConcepts()
        );
      }
    } catch (error) {
      console.error('Error al obtener las columnas de los conceptos de facturación.', error);
    }
  }

  async getCostCentersForInvoicingCutoff() {
    try {
      this.dataCostCenters = await firstValueFrom(
        this.invoicingCutoffDetailService.getCostCentersForInvoicingCutoffAsync(
          this.invoicingCutoffContract.invoicingCutoffId,
          this.pageCostCenter,
          this.limitCostCenter,
          this.columnSortCostCenter,
          this.ascendantCostCenter,
          this.filtersCostCenters
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los centros de costos', error);
    }
  }

  getFormatType(formatType: any) {
    this.formatType = formatType == 1;
  }

  async getInvoicingConceptsForInvoicingCutoff() {
    try {
      this.dataInvoicingConcept = await firstValueFrom(
        this.invoicingCutoffDetailService.getInvoicingConceptsForInvoicingCutoffAsync(
          this.invoicingCutoffContract.invoicingCutoffId,
          this.pageInvoicingConcept,
          this.limitInvoicingConcept,
          this.columnSortInvoicingConcept,
          this.ascendantInvoicingConcept,
          this.filtersInvoicingConcept
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los conceptos de facturación.', error);
    }
  }

  async getEnterprise(enterpriseId: number | null) {
    if (enterpriseId !== null && enterpriseId !== 0) {
      this.enterpriseId = enterpriseId;
      this.formInvoicingCutoff.controls["enterpriseId"].setValue(enterpriseId);
      const enterprise = this.listEnterprise.find(x => x.value === enterpriseId);
      if (enterprise) {
        this.swElectronicInvoice = enterprise ? enterprise.swElectronicInvoice : false;
        this.updateInputs(true);
      }
    } else {
      this.enterpriseId = 0;
      this.formInvoicingCutoff.controls["enterpriseId"].setValue(0);
    }
  }

  getFilterPreview(filters: any[]) {
    this.clientId = filters.find(x => x.label == 'clientId').value;
    this.costCenterId = filters.find(x => x.label == 'costCenterId').value;
    this.costCenterTypeId = filters.find(x => x.label == 'costCenterTypeId').value;

    this.getPrintPreinvoincing();
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      this.mainBranchByUser = await firstValueFrom(this.userAuthenticatedService.branchObservable.pipe(filter(branch => branch && branch.branchId !== 0)));
      this.companyId = this.mainBranchByUser.companyId;
      this.branchId = this.mainBranchByUser.branchId;
      await this.getBranch(this.mainBranchByUser.branchId, false);
      this.getFirstEnterpriseByBranch(this.branchId);
      this.formInvoicingCutoff.controls["branchId"].patchValue(this.mainBranchByUser.branchId);
    } catch (error) {
      console.error('Error al obtener la primera sucursal por usuario autenticado:', error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number | null) {
    if (branchId != null && branchId != 0) {
      try {
        const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
        if (!response) {
          this.enterpriseId = 0;
          this.toastHandlerService.showToast(
            'error',
            'La Sucursal no tiene Empresas creadas.'
          );
          return;
        };
        this.getEnterprise(response.enterpriseId);
      } catch (error) {
        console.error('Error al obtener la primera empresa por sucursal:', error);
      }
    }
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0)
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.preinvoicing));
  }

  async getGeneralParameter() {
    if (this.companyId != null && this.companyId != 0) {
      try {
        const response = await firstValueFrom(this.generalParameterService.getGeneralParametersByCompany(this.companyId));
        this.swServicesFullSeparately = response.find(x => x.generalParameterId == GeneralParameterEnums.serviciosFullAparte) != null;
        this.swSpecialInvoicing = response.find(x => x.generalParameterId == GeneralParameterEnums.facturacionEspecial) != null;
        this.swPartialInvoicing = response.find(x => x.generalParameterId == GeneralParameterEnums.facturacionParcial) != null;
        this.swAdvanceInvoice = response.find(x => x.generalParameterId == GeneralParameterEnums.facturaAnticipada) != null;
      } catch (error) {
        console.error('Error al obtener parámetros generales:', error);
      }
    }
  }

  async getInvoicingCutoffById() {
    try {
      this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.getInvoicingCutoffById(this.invoicingCutoffId, this.invoicingCutoffIdToUnlock));
      this.invoicingCutoffId = this.invoicingCutoffContract.invoicingCutoffId;
      this.invoicingCutoffIdToUnlock = this.invoicingCutoffId;
      this.router.navigate([`/invoicing-cutoff/register/${this.invoicingCutoffId}`]);
    } catch (error) {
      console.error('Error al obtener el corte por Id.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    await this.getGeneralParameter();
    this.getFormatByCompanyAndCode();
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.getPermissionsForUserByWindow();
      await this.getAllLists(false);
      await this.getAllListFilters();
    } catch (error) {
      console.error('Error getting profile permissions.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.InvoicingCutoff));
  }

  async getPrintPreinvoincing() {
    try {
      this.visibleLoading = true;
      this.preinvoicingPrintModel = await firstValueFrom(this.movementService.getPrintPreinvoices(this.invoicingCutoffId, this.clientId, this.costCenterTypeId, this.costCenterId));
      if (this.preinvoicingPrintModel.length == 0) {
        this.toastHandlerService.showToast(
          'info',
          'No hay datos disponibles.'
        );
      }
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  getQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
    if (this.quantityDetails > 0) {
      this.disabledForm = true;
      setTimeout(() => this.formInvoicingCutoff.disable(), 100);
      setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['branchId', 'consecutive'], true), 100);
      if (this.swAdvanceInvoice) {
        setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], true), 100);
      } else {
        setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], false), 100);
      }
    } else {
      this.updateFormState();
    }
  }

  async getUserBlock(userBlockId: number | null) {
    this.userIdBlock = userBlockId;
    if (userBlockId !== null && userBlockId !== 0) {
      try {
        this.userNameBlock = await firstValueFrom(this.invoicingCutoffService.getUserBlockByIdAsync(userBlockId));
      } catch (error) {
        this.userNameBlock = "";
        console.error('Error al obtener el usuario que bloqueo el documento.', error);
      }
    } else {
      this.userNameBlock = "";
    }
    this.updateFormState();
  }

  goToBack(event: Event) {
    event.preventDefault();
    if (this.previewInvoicingCutoff) {
      this.previewInvoicingCutoff = false;
      this.iconPreviewInvoicingCutoff = "pi pi-eye";
      this.titlePreviewInvoicingCutoff = "Vista Previa";
      this.formatType = true;
      this.format.patchValue(1);
    } else {
      this.router.navigate(['/invoicing-cutoff']);
    }
  }

  async handleInitialState() {
    if (this.invoicingCutoffId !== null && this.invoicingCutoffId !== 0) {
      await this.getInvoicingCutoffById();
      if (this.invoicingCutoffContract.invoicingCutoffId !== 0) {
        this.formInvoicingCutoff.enable();
        this.validateForm(this.invoicingCutoffContract);
        this.getBranch(this.invoicingCutoffContract.branchId, false);

        if (!this.permissionUpdatable) {
          this.updateFormPermision();
        }
      }
    } else {
      this.createNewInvoicingCutoff(0);
    }
  }

  async onFilterChangeInvoicingConcept(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersInvoicingConcept = this.removeDuplicates(filters);
    this.filtersInvoicingConcept.forEach((filter: any) => this.processFilterInvoicingConcept(filter));
    this.updateInputs();
  }


  async onFilterChangeCostCenter(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersCostCenters = this.removeDuplicates(filters);
    this.filtersCostCenters.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeConcept(event: {
    page: number;
    pageSize: number;
    sortField: string | undefined;
    sortOrder: number;
  }) {
    this.pageInvoicingConcept = event.page;
    this.limitInvoicingConcept = event.pageSize;
    this.columnSortInvoicingConcept = event.sortField || null;
    this.ascendantInvoicingConcept = event.sortOrder === 1;
    this.getInvoicingConceptsForInvoicingCutoff();
  }

  async onPageChangeCostCenter(event: {
    page: number;
    pageSize: number;
    sortField: string | undefined;
    sortOrder: number;
  }) {
    this.pageCostCenter = event.page;
    this.limitCostCenter = event.pageSize;
    this.columnSortCostCenter = event.sortField || null;
    this.ascendantCostCenter = event.sortOrder === 1;
    this.getCostCentersForInvoicingCutoff();
  }

  onQuantityThirdChange(value: number) {
    this.quantityCostCenterTypeThird = value;
    this.updateInputs(true);
  }

  async openInvoicingModal() {
    if (this.permissionUpdatable) {
      await this.thereDetailsWithoutMovements();
      //Si hay ccos. que no generan mvto. Válido si se eliminan
      if (this.detailWithoutMovement) {
        const accepted = await this.confirmDialogService.confirm("Para facturar, se eliminarán de este corte los c.costos sin movimiento.<br>¿Desea continuar?");
        if (accepted) {
          if (this.swPartialInvoicing) {
            this.filtersInvoicingConcept = [];
            this.updateInputs();
            await Promise.all([
              this.getColumnsInvoicingConcepts(),
              this.getInvoicingConceptsForInvoicingCutoff(),
            ]);

            if (this.invoicingConceptModalComponent && this.headerInvoicingConcept) {
              this.invoicingConceptModalComponent.show();
            } else {
              this.toastHandlerService.showToast(
                'error',
                'No se pudieron cargar los conceptos de facturación. Por favor, inténtelo de nuevo.'
              );
            }
          } else {
            this.invoicingModalComponent && this.invoicingModalComponent.show();
          }
        }
      } else {
        if (this.swPartialInvoicing) {
          this.filtersInvoicingConcept = [];
          this.updateInputs();
          await Promise.all([
            this.getColumnsInvoicingConcepts(),
            this.getInvoicingConceptsForInvoicingCutoff(),
          ]);

          if (this.invoicingConceptModalComponent && this.headerInvoicingConcept) {
            this.invoicingConceptModalComponent.show();
          } else {
            this.toastHandlerService.showToast(
              'error',
              'No se pudieron cargar los conceptos de facturación. Por favor, inténtelo de nuevo.'
            );
          }
        } else {
          this.invoicingModalComponent && this.invoicingModalComponent.show();
        }
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estado del corte de facturación. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async openPreInvoicingModal() {
    if (this.permissionUpdatable) {
      if (this.invoicingCutoffContract.invoicingCutoffStateId == InvoicingCutoffEnums.estadoAbierto) {
        this.preInvoicingModalComponent && this.preInvoicingModalComponent.show();
      } else if (this.invoicingCutoffContract.invoicingCutoffStateId == InvoicingCutoffEnums.estadoPrefacturado ||
        this.invoicingCutoffContract.invoicingCutoffStateId == InvoicingCutoffEnums.estadoSuspendido) {
        try {
          this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.openInvoicingCutoffById(this.invoicingCutoffContract.invoicingCutoffId));
          this.validateForm(this.invoicingCutoffContract);
        } catch (error) {
          console.error('Error al abrir el corte de facturación.', error);
        }
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estado del corte de facturación. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async openPreviewInvoicingCutoff() {
    if (this.invoicingCutoffContract.invoicingCutoffId != 0) {
      this.previewInvoicingCutoff = !this.previewInvoicingCutoff;
      if (this.previewInvoicingCutoff) {
        this.iconPreviewInvoicingCutoff = "pi pi-address-book";
        this.titlePreviewInvoicingCutoff = "Volver al corte de facturación";
        this.getPrintPreinvoincing();
      } else {
        this.iconPreviewInvoicingCutoff = "pi pi-eye";
        this.titlePreviewInvoicingCutoff = "Vista Previa";
      }
    } else {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado del corte de facturación.`, 'Atención');
    }
  }

  async openSelectCostCenterModal() {
    if (this.invoicingCutoffContract.invoicingCutoffId === 0) {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado del corte de facturación.`, 'Atención');
      return;
    }
    this.filtersCostCenters = [];
    await Promise.all([
      this.getColumnsCostCenters(),
      this.getCostCentersForInvoicingCutoff(),
    ]);
    this.updateInputs();

    if (this.selectCostCenterModalComponent && this.headerCostCenters) {
      this.selectCostCenterModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'error',
        'No se pudieron cargar los centros de costos. Por favor, inténtelo de nuevo.'
      );
    }
  }

  async partialInvoicing(invoicingConcepts: InvoicingCutoffInvoicingConceptModal[]) {
    if (invoicingConcepts.length != 0) {
      const movementIds = invoicingConcepts.map(d => d.movementId);
      this.movementToInvoice = movementIds;
      this.updateInputs(true);
      this.invoicingModalComponent && this.invoicingModalComponent.show();
    } else {
      this.toastHandlerService.showToast('error', 'Error al seleccionar los registros. Por favor, inténtelo de nuevo.');
    }
  }

  printPreinvoicing() {
    this.toastHandlerService.clearAllToasts();
    setTimeout(() => window.print(), 100);
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (
      valueFilter === null ||
      valueFilter === undefined ||
      valueFilter === '' ||
      valueFilter === 0
    ) {
      this.filtersCostCenters = this.filtersCostCenters.filter(
        (f) => f.propertyName !== propertyName
      );
    } else {
      const existingFilter = this.filtersCostCenters.find(
        (f) => f.propertyName === propertyName
      );
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  processFilterInvoicingConcept(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (
      valueFilter === null ||
      valueFilter === undefined ||
      valueFilter === '' ||
      valueFilter === 0
    ) {
      this.filtersInvoicingConcept = this.filtersInvoicingConcept.filter(
        (f) => f.propertyName !== propertyName
      );
    } else {
      const existingFilter = this.filtersInvoicingConcept.find(
        (f) => f.propertyName === propertyName
      );
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    Object.keys(this.formInvoicingCutoff.controls).forEach(key => {
      const control = this.formInvoicingCutoff.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formInvoicingCutoff.valid) {
      const modelInvoicingCutoff = this.formInvoicingCutoff.getRawValue() as InvoicingCutoffModel;

      if (!this.swServicesFullSeparately) {
        modelInvoicingCutoff.invoicingCutoffTypeId = InvoicingCutoffEnums.tipoCompleto;
      } else {
        if (modelInvoicingCutoff.invoicingCutoffTypeId != InvoicingCutoffEnums.tipoMovimiento &&
          modelInvoicingCutoff.invoicingCutoffTypeId != InvoicingCutoffEnums.tipoServicio) {
          this.toastHandlerService.showToast(
            'warning',
            'Seleccione un tipo de corte válido'
          );
          return;
        }
      }
      if (modelInvoicingCutoff.observation?.trim() == "") modelInvoicingCutoff.observation = null;

      //Si la compañía tiene sw de facturación especial es obligatorio que tenga una observación:
      if (!await this.validateObservationForSpecialInvoicing(modelInvoicingCutoff)) return;

      if (this.invoicingCutoffId == 0) {
        try {
          this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.createInvoicingCutoff(modelInvoicingCutoff));
          this.invoicingCutoffId = this.invoicingCutoffContract.invoicingCutoffId;
          this.validateForm(this.invoicingCutoffContract);
          this.toastHandlerService.showToast(
            'success',
            'El corte de facturación fue creado exitosamente.'
          );
          this.location.replaceState(`/invoicing-cutoff/register/${this.invoicingCutoffId}`);
        } catch (error) {
          console.error('Error al crear el corte de facturación:', error);
        }
      } else {
        this.invoicingCutoffContract.enterpriseId = modelInvoicingCutoff.enterpriseId;
        this.invoicingCutoffContract.dateCutoff = modelInvoicingCutoff.dateCutoff;
        this.invoicingCutoffContract.invoicingCutoffTypeId = modelInvoicingCutoff.invoicingCutoffTypeId;
        this.invoicingCutoffContract.observation = modelInvoicingCutoff.observation;
        this.invoicingCutoffContract.invoicingCutoffClass = modelInvoicingCutoff.invoicingCutoffClass;

        try {
          this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.updateInvoicingCutoff(this.invoicingCutoffContract));
          this.validateForm(this.invoicingCutoffContract);
          this.toastHandlerService.showToast(
            'success',
            'El corte de facturación fue modificado exitosamente.'
          );
        } catch (error) {
          console.error('Error al actualizar el corte de facturación:', error);
        }
      }
    } else {
      this.showValidationMessages();
    }

  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debes seleccionar una Sucursal válida.'
      },
      consecutive: {
        required: 'El campo Consecutivo es obligatorio.'
      },
      enterpriseId: {
        required: 'El campo Empresa es obligatorio.',
        min: 'Debes seleccionar una Empresa válida.'
      },
      dateCutoff: {
        required: 'La Fecha de Corte es obligatoria.'
      },
      invoicingCutoffStateId: {
        required: 'El Estado del Corte es obligatorio.',
        min: 'Debes seleccionar un Estado de Corte válido.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInvoicingCutoff.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async suspendInvoicingCutoff() {
    const accepted = await this.confirmDialogService.confirm("¿Realmente desea SUSPENDER este corte?<br> No se podrá abrir nuevamente si se crea un corte posterior para alguno de estos centro de costos, solo se dejará facturar.");
    if (accepted) {
      this.invoicingCutoffContract = await firstValueFrom(this.invoicingCutoffService.suspendInvoicingCutoffById(this.invoicingCutoffId));
      this.validateForm(this.invoicingCutoffContract);
      this.toastHandlerService.showToast(
        'success',
        'El proceso ha terminado exitosamente.'
      );
    }
  }

  async thereDetailsWithoutMovements() {
    try {
      this.detailWithoutMovement = await firstValueFrom(this.invoicingCutoffDetailService.thereDetailsWithoutMovements(this.invoicingCutoffId));
    } catch (error) {
      console.error('Error al buscar si existen detalles sin movimiento.', error);
    }
  }

  async thereIsCostCenterWithAlerts() {
    await this.thereDetailsWithoutMovements();
    //Si hay ccos. que no generan mvto o con alertas, se habilita la opcion de eliminarlos directamente
    if (this.detailWithoutMovement && this.invoicingCutoffContract.invoicingCutoffStateId == InvoicingCutoffEnums.estadoPrefacturado) {
      this.costCenterWithAlerts = true;
    } else {
      this.costCenterWithAlerts = false;
    }
  }

  updateInputs(preinvoicingModal: boolean = false) {
    if (preinvoicingModal) {
      this.inputsForPreInvoicingModal$.next({
        enterpriseId: this.enterpriseId,
        invoicingCutoffId: this.invoicingCutoffId,
        branchName: this.listBranch.find(x => x.value === this.invoicingCutoffContract.branchId).label,
        invoicingCutoffCode: this.invoicingCutoffContract.consecutive,
        invoicingCutoffDate: formatDate(this.dateConverterService.convertUtcToLocalDate(this.invoicingCutoffContract.dateCutoff), 'dd/MM/yyyy', 'en-US'),
        quantityCostCenterTypeThird: this.quantityCostCenterTypeThird,
        swElectronicInvoice: this.swElectronicInvoice,
        movementToInvoice: this.movementToInvoice,
      });
    } else {
      this.inputsForCostCenterModal$.next({
        headers: this.headerCostCenters,
        data: this.dataCostCenters,
        showCheckbox: true,
        showRecover: true,
        isMultipleSelect: true,
        filters: this.filtersCostCenters,
      });
      this.inputsForInvoicingConceptModal$.next({
        headers: this.headerInvoicingConcept,
        data: this.dataInvoicingConcept,
        showCheckbox: true,
        showRecover: true,
        isMultipleSelect: true,
        selectAllByDefault: true,
        filters: this.filtersInvoicingConcept,
      });
    }
  }

  async updateInvoicingCutoff(params: any) {
    if (params.reload) {
      this.invoicingCutoffIdToUnlock = 0;
      await this.getInvoicingCutoffById();
      this.validateForm(this.invoicingCutoffContract);
    }
  }

  updateFilters() {
    const filters = [
      { label: 'clientId', value: this.clientId },
      { label: 'costCenterId', value: this.costCenterId },
      { label: 'costCenterTypeId', value: this.costCenterTypeId },
    ];
    this.filtersPreview = filters;
    this.getFilterPreview(filters);
  }

  updateFormPermision() {
    switch (this.invoicingCutoffContract.invoicingCutoffStateId) {
      case InvoicingCutoffEnums.estadoAbierto: {
        this.invoicingCutoffStateString = "Abierto";
        this.preinvoicingCutoffStateString = "Prefacturar";
        break;
      }
      case InvoicingCutoffEnums.estadoPrefacturado: {
        this.invoicingCutoffStateString = "Prefacturado";
        this.preinvoicingCutoffStateString = "Abrir";
        break;
      }
      case InvoicingCutoffEnums.estadoSuspendido: {
        this.invoicingCutoffStateString = "Suspendido";
        this.preinvoicingCutoffStateString = "Abrir";
        break;
      }
      case InvoicingCutoffEnums.estadoFacturado: {
        this.invoicingCutoffStateString = "Facturado";
        this.preinvoicingCutoffStateString = "Abrir";
        break;
      }
    }

    this.disabledDetail = false;
    this.disabledForm = true;
    this.disabledState = false;
    this.disabledInvoice = true;
    this.disabledSuspend = true;
    this.disabledSelectCostCenter = true;

    setTimeout(() => this.formInvoicingCutoff.disable(), 100);
    setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['branchId', 'consecutive'], true), 100);
    if (this.swAdvanceInvoice) {
      setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], true), 100);
    } else {
      setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], false), 100);
    }
  }

  updateFormState() {
    switch (this.invoicingCutoffContract.invoicingCutoffStateId) {
      case InvoicingCutoffEnums.estadoAbierto: {
        this.invoicingCutoffStateString = "Abierto";
        this.preinvoicingCutoffStateString = "Prefacturar";
        break;
      }
      case InvoicingCutoffEnums.estadoPrefacturado: {
        this.invoicingCutoffStateString = "Prefacturado";
        this.preinvoicingCutoffStateString = "Abrir";
        break;
      }
      case InvoicingCutoffEnums.estadoSuspendido: {
        this.invoicingCutoffStateString = "Suspendido";
        this.preinvoicingCutoffStateString = "Abrir";
        break;
      }
      case InvoicingCutoffEnums.estadoFacturado: {
        this.invoicingCutoffStateString = "Facturado";
        this.preinvoicingCutoffStateString = "Abrir";
        break;
      }
    }

    if (this.userIdBlock === null || this.userIdBlock === this.userAuthenticated.userId) {
      this.visibleBlock = false;
      if (this.invoicingCutoffContract.invoicingCutoffStateId == InvoicingCutoffEnums.estadoPrefacturado) {
        this.disabledDetail = false;
        this.disabledForm = true;
        this.disabledInvoice = false;
        this.disabledSelectCostCenter = true;
        this.disabledState = true;
        this.disabledSuspend = false;
        setTimeout(() => this.formInvoicingCutoff.disable(), 100);
        setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['branchId', 'consecutive'], true), 100);
        if (this.swAdvanceInvoice) {
          setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], true), 100);
        } else {
          setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], false), 100);
        }
      } else if (this.invoicingCutoffContract.invoicingCutoffStateId == InvoicingCutoffEnums.estadoSuspendido) {
        this.disabledDetail = false;
        this.disabledForm = true;
        this.disabledInvoice = false;
        this.disabledSelectCostCenter = true;
        this.disabledState = true;
        this.disabledSuspend = true;
        if (this.swPartialInvoicing) this.disabledState = false;
        setTimeout(() => this.formInvoicingCutoff.disable(), 100);
        setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['branchId', 'consecutive'], true), 100);
        if (this.swAdvanceInvoice) {
          setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], true), 100);
        } else {
          setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], false), 100);
        }
      } else if (this.invoicingCutoffContract.invoicingCutoffStateId == InvoicingCutoffEnums.estadoFacturado) {
        this.disabledDetail = true;
        this.disabledForm = true;
        this.disabledInvoice = true;
        this.disabledSelectCostCenter = true;
        this.disabledState = false;
        this.disabledSuspend = true;
        setTimeout(() => this.formInvoicingCutoff.disable(), 100);
        setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['branchId', 'consecutive'], true), 100);
        if (this.swAdvanceInvoice) {
          setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], true), 100);
        } else {
          setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], false), 100);
        }
      } else {
        this.disabledDetail = true;
        this.disabledForm = false;
        this.disabledInvoice = true;
        this.disabledSelectCostCenter = false;
        this.disabledState = true;
        this.disabledSuspend = true;
        setTimeout(() => this.formInvoicingCutoff.enable(), 100);
        if (this.invoicingCutoffId !== 0) {
          setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['branchId', 'consecutive'], true), 100);
        } else {
          setTimeout(() => this.formInvoicingCutoff.controls["consecutive"].disable(), 100);
        }
        if (this.swAdvanceInvoice) {
          setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], true), 100);
        } else {
          setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], false), 100);
        }
      }
    } else {
      this.disabledDetail = false;
      this.disabledForm = true;
      this.visibleBlock = true;
      this.disabledInvoice = true;
      this.disabledSuspend = true;
      this.disabledSelectCostCenter = true;
      this.disabledState = false;
      setTimeout(() => this.formInvoicingCutoff.disable(), 100);
      setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['branchId', 'consecutive'], true), 100);
      if (this.swAdvanceInvoice) {
        setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], true), 100);
      } else {
        setTimeout(() => this.formControlStateService.setControlState(this.formInvoicingCutoff, ['invoicingCutoffClass'], false), 100);
      }
    }
  }

  async validateCountInvoicingCutoffsOpen(branchId: number) {
    try {
      const response = await firstValueFrom(this.invoicingCutoffService.validateCountInvoicingCutoffsOpen(branchId));
      this.companyCutsAmount = response[0] as number; //Si la cantidad es 0 es porque no hay límite de cortes abiertos
      this.openCutsAmount = response[1] as number; if (this.openCutsAmount != 0) {
        if (this.companyCutsAmount == 0) {
          this.toastHandlerService.showToast(
            'info',
            `Existen (${this.openCutsAmount} corte(s) con estado abierto o prefacturado.`
          );
        } else {
          //Mensaje con el número de cortes
          this.toastHandlerService.showToast(
            'info',
            `Existen (${this.openCutsAmount}) Corte(s) con estado abierto o prefacturado. El máximo de cortes permitidos son (${this.companyCutsAmount})`
          );
        }
      }
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  async validateForm(invoicingCutoffModel: InvoicingCutoffModel) {
    this.formInvoicingCutoff = this.formBuilder.group({
      branchId: [invoicingCutoffModel.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [invoicingCutoffModel.consecutive, [Validators.required]],
      enterpriseId: [invoicingCutoffModel.enterpriseId, [Validators.required, Validators.min(1)]],
      dateCutoff: [invoicingCutoffModel.dateCutoff ? this.dateConverterService.convertDatePreserveDay(invoicingCutoffModel.dateCutoff) : null, [Validators.required]],
      invoicingCutoffStateId: [invoicingCutoffModel.invoicingCutoffStateId, [Validators.required, Validators.min(1)]],
      preInvoicingStateId: [invoicingCutoffModel.preInvoicingStateId],
      invoicingCutoffTypeId: [invoicingCutoffModel.invoicingCutoffTypeId],
      observation: [invoicingCutoffModel.observation, [Validators.maxLength(250)]],
      invoicingCutoffClass: [invoicingCutoffModel.invoicingCutoffClass],
    });
    this.updateFormState();
    if (invoicingCutoffModel.invoicingCutoffId !== 0) {
      this.getEnterprise(this.invoicingCutoffContract.enterpriseId);
      this.updateInputs(true);
      this.getUserBlock(invoicingCutoffModel.userIdBlock);
    }
    if (invoicingCutoffModel.invoicingCutoffClass === InvoicingCutoffClassEnum.advanceInvoice) {
      this.hiddenSuspendBtn = true;
    } else {
      this.hiddenSuspendBtn = false;
    }
  }

  async validateObservationForSpecialInvoicing(modelInvoicingCutoff: InvoicingCutoffModel): Promise<boolean> {
    if (this.swSpecialInvoicing && modelInvoicingCutoff.observation == null) {
      const accepted = await this.confirmDialogService.confirm(
        "El campo de observación es requerido debido a que la compañía tiene facturación especial.<br> ¿Realmente desea guardar este corte sin observación?"
      );
      if (accepted) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  visiblePreview(visible: boolean) {
    this.visibleLoading = !visible;
  }

}
